import { Box } from "@mui/material";
import { getLayoutBody } from "./getLayoutBody";
import { getLayoutHead } from "./getLayoutHead";
export function getLayoutView(h, t, s, c = {}) {
  return (
    <Box
      sx={{
        backgroundColor: "white",
        justifyContent: "center",
        flexDirection: "column",
        display: "flex",
        p: "5rem 10% 8rem",
        ...c,
      }}
    >
      {getLayoutHead(h)}
      {getLayoutBody(t, s)}
    </Box>
  );
}
